import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaInstallService } from '../../../core/services/pwa-install.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-pwa-install-banner',
    imports: [CommonModule],
    templateUrl: './pwa-install-banner.component.html',
    styleUrl: './pwa-install-banner.component.scss'
})
export class PwaInstallBannerComponent implements OnInit, OnDestroy {
  show = false;
  private sub: Subscription | null = null;

  constructor(private pwaInstall: PwaInstallService) {}

  ngOnInit(): void {
    if (this.pwaInstall.wasDismissed()) return;
    this.sub = this.pwaInstall.canInstall.subscribe((v) => {
      this.show = v;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  async install(): Promise<void> {
    await this.pwaInstall.promptInstall();
    this.show = false;
  }

  dismiss(): void {
    this.pwaInstall.dismissBanner();
    this.show = false;
  }
}
